import { forwardRef } from 'react';

import { CloseIcon } from '@braskai/icons';
import { Typography } from '@braskai/ui-kit';

import { Box, Stack } from '@mui/material';

import { RouterLink } from '../RouterLink';
import { SCloseButton, SContainer, SIconContainer } from './styled';
import { PromoBannerProps } from './types';

export const PromoBanner = forwardRef<HTMLDivElement, PromoBannerProps>(
  ({ title, icon, link, variant = 'grey', onClose, ...props }, ref) => (
    <SContainer $variant={variant} gap={8} padding={12} ref={ref} {...props}>
      {icon && <SIconContainer $variant={variant}>{icon}</SIconContainer>}
      <Stack gap={4}>
        <Typography
          color="grey.700"
          sx={{ width: { mobile: 'calc(100% - 30px)', mobileLarge: 'auto' } }}
          variant="caption-1"
        >
          {title}
        </Typography>
        {link && (
          <Box
            sx={{
              lineHeight: 0,
            }}
          >
            <RouterLink color={variant} size="md" {...link} />
          </Box>
        )}
      </Stack>

      {onClose && (
        <SCloseButton
          title="Close"
          $color={variant}
          data-testid="promo-banner-close"
          startIcon={<CloseIcon />}
          type="button"
          variant="link"
          noPadding
          onClick={onClose}
        />
      )}
    </SContainer>
  ),
);
